import { render, staticRenderFns } from "./HazardListScreen.vue?vue&type=template&id=11d40feb"
import script from "./HazardListScreen.vue?vue&type=script&lang=ts"
export * from "./HazardListScreen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports